var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mob-application-value-item",style:({ backgroundImage: `url(${_vm.info.bgMobImg})` })},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.info.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }